import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const GET_FAMILY_GROUPS_BY_IDS_QUERY = gql`
  query GetFamilyGroupsByIds($cloudIds: [String!]!) {
    getFamilyGroupsByIds(cloudIds: $cloudIds) {
      cloudId
      name
      endDateUtc
      isDeleted
    }
  }
` as import('../../__generated__/ts-gql/GetFamilyGroupsByIds').type;
export type GetFamilyGroupsByIdsQueryResult = OperationData<
  typeof GET_FAMILY_GROUPS_BY_IDS_QUERY
>;
export type GetFamilyGroupsByIdsQueryVariables = OperationVariables<
  typeof GET_FAMILY_GROUPS_BY_IDS_QUERY
>;

export const useGetFamilyGroupsByIds = (
  options: QueryHookOptions<
    GetFamilyGroupsByIdsQueryResult,
    GetFamilyGroupsByIdsQueryVariables
  >
) => {
  const variables = options.variables as GetFamilyGroupsByIdsQueryVariables;

  const res = useQuery(GET_FAMILY_GROUPS_BY_IDS_QUERY, {
    context: { service: 'clients' },
    variables,
    ...options,
  });

  const { data } = res;
  return React.useMemo(
    () => ({ ...res, data: data ? processData(data) : null }),
    [res, data]
  );
};

export function processData(data: GetFamilyGroupsByIdsQueryResult) {
  const rawRows = data?.getFamilyGroupsByIds;
  const result:
    | GetFamilyGroupsByIdsQueryResult['getFamilyGroupsByIds']
    | undefined = rawRows?.map((raw) => ({
    ...raw,
    endDateUtc: raw.endDateUtc && new Date(raw.endDateUtc),
  }));
  return result;
}
